export default{
    getFeedback: (state) => {
        return state.feedback
    }
}